import React, { useEffect, useRef } from "react";
//import Loading from "../components/layouts/loading";

export default function LiveviewCardFB({ liveview, isShow }) {

    const elementRef = useRef();

    useEffect(() => {
        window.FB.XFBML.parse(elementRef.current);
    }, [isShow]);

    //data-lazy="true"
    return liveview && (
        <>
            <div ref={elementRef} style={{ textAlign: 'center' }}>
                {isShow === true ?
                    <div className="fb-video" data-href={liveview.fb_url} data-width="320" data-show-text="false">
                    </div> : <div></div>}
                <br></br>
                <span style={{ fontSize: "0.6rem" }}>(example: https://www.facebook.com/StartupItalia.eu/videos/xxxxx)</span>
            </div>
        </>
    );
}
